import Decimal from "decimal.js";

interface ValidateDecimalOptions {
  readonly maxDecimalPlaces?: number;
  readonly customError?: string;
  readonly nonNegative?: boolean;
  readonly greaterThan?: number;
}
export const validateDecimal = (value: string, translate: CallableFunction, options: ValidateDecimalOptions = {}) => {
  const {
    maxDecimalPlaces,
    customError,
    nonNegative,
    greaterThan,
  } = options;
  let decimal;
  try {
    decimal = new Decimal(value);
  } catch (err) {
    return customError || translate("FORM_FIELD_VALIDATION_ERRORS.youMustProvideValidNumber");
  }

  if (maxDecimalPlaces && decimal.decimalPlaces() > maxDecimalPlaces) {
    return translate("FORM_FIELD_VALIDATION_ERRORS.cannotHaveMoreThanNDecimal", { maxDecimalPlaces });
  }

  if (nonNegative && decimal.lessThan(new Decimal(0))) {
    return translate("FORM_FIELD_VALIDATION_ERRORS.youMustProvideAPositiveNumber");
  }

  if (greaterThan !== undefined && greaterThan !== null && decimal.lessThanOrEqualTo(new Decimal(greaterThan))) {
    return translate("FORM_FIELD_VALIDATION_ERRORS.youMustProvideANumberBiggerThanN", { biggerThan: greaterThan });
  }

  return undefined;
};
